import { Link } from "react-router-dom";

const LogoCardsTitle = (props) => {
  return (
    <div className="logo_cards_heading_container">
      <div className="logo_cards_heading_wrapper">
        <h2>{props.heading}</h2>
      </div>
      <div className="view_more_container">
        <Link to="/works">
          <button>View more</button>
        </Link>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1rem"
          height="1rem"
          viewBox="0 0 24 24"
        >
          <rect width="24" height="24" fill="none" />
          <path
            fill="none"
            stroke="#6f6f6f"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M4 12h16m0 0l-6-6m6 6l-6 6"
          />
        </svg>
      </div>
    </div>
  );
};

export default LogoCardsTitle;
